module.exports = __webpack_public_path__ + "img/cepillo_dientes.84f17eef.png";